import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import * as AOS from 'aos';
import { Title, Meta } from '@angular/platform-browser';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-oee-improvement-for-manufacturing-blog',
  templateUrl: './oee-improvement-for-manufacturing-blog.component.html',
  styleUrls: ['./oee-improvement-for-manufacturing-blog.component.css']
})
export class OEEImprovementForManufacturingBlogComponent {
  baseUrl = Constants.baseUrl;
  isBrowser: boolean = false;
  constructor(
    private titleService: Title, @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta
  ) { this.isBrowser = isPlatformBrowser(this.platformId); }
  ngOnInit() {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
  {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "https://mitresource.com/oee-improvement-for-manufacturing/"
    },
    "headline": "Power Up your Production: Strategies for OEE Improvement in Your Manufacturing business",
    "description": "Manufacturers have a constant goal of keeping production on track while minimizing costs and delays.",
    "image": "https://mitresource.com/assets/images/blogs/smart-manufacturing-blog.webp",  
    "author": {
      "@type": "Organization",
      "name": "Maganti IT",
      "url": "https://mitresource.com/"
    },  
    "publisher": {
      "@type": "Organization",
      "name": "Maganti IT",
      "logo": {
        "@type": "ImageObject",
        "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
      }
    },
    "datePublished": "2024-07-18"
  }`;

    this._renderer2.appendChild(this._document.head, script);
    if (this.isBrowser) {
      AOS.init({ disable: 'mobile' });
    }

    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }
  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Power Up your Production: Strategies for OEE Improvement in Your Manufacturing business');

    this.metaService.addTags([
      { name: 'description', content: 'Manufacturers have a constant goal of keeping production on track while minimizing costs and delays.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Power Up your Production: Strategies for OEE Improvement in Your Manufacturing business' },
      { property: 'og:url', content: 'https://mitresource.com/oee-improvement-for-manufacturing/' },
      { property: 'og:image', content: 'https://mitresource.com/assets/images/blogs/oee-improvement-banner.webp' },
      { property: 'og:description', content: 'Manufacturers have a constant goal of keeping production on track while minimizing costs and delays.' },
    ]);
  }
}
